// src/services/auth.js
import api from "api/axios";

const TENANT_SLUG_RE = /^(?!-)[a-z0-9-]{1,63}(?<!-)$/;

const setTenant = (company) => {
  if (company) {
    try {
      localStorage.setItem("company", company);
    } catch {}
  }
};
const getCookie = (name) => {
  const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
  return m ? m.pop() : "";
};
export const hasCsrf = () => Boolean(getCookie("csrftoken"));

export const csrfBootstrap = async (company) => {
  if (company) setTenant(company);
  const c = company || localStorage.getItem("company") || "";
  const headers = { "X-Requested-With": "XMLHttpRequest" };
  if (c) headers["X-Tenant"] = c; // 👉 explicite
  try {
    await api.get("/public_auth/csrf/", {
      params: c ? { schema: c } : {},
      headers,
    });
  } catch {
    await api.get("/public_auth/csrf/", { headers });
  }
  if (!hasCsrf()) await new Promise((r) => setTimeout(r, 25));
};

// Best-effort CSRF
export async function ensureCsrf(companyArg) {
  if (hasCsrf()) return true;
  try {
    const c = companyArg || localStorage.getItem("company") || "";
    await csrfBootstrap(c);
  } catch {}
  return hasCsrf();
}

/**
 * 🔐 Login universel — accepte un 2e param `config` (ex: { headers: { "X-Tenant": c } })
 */
export const universalLogin = async ({ username, password, company }, config = {}) => {
  const u = (username || "").trim();
  const p = password || "";
  const c = (company || "").trim().toLowerCase();

  if (!u || !p || !c) throw new Error("username, password et company sont requis.");
  if (!TENANT_SLUG_RE.test(c)) {
    throw new Error("Format de 'company' invalide (minuscules/chiffres/tirets, 1–63 car.).");
  }

  setTenant(c);
  await csrfBootstrap(c);

  // merge headers sans écraser ceux fournis
  const cfg = {
    ...(config || {}),
    headers: { ...(config?.headers || {}), "X-Tenant": c },
  };

  try {
    const res = await api.post(
      "/public_auth/universal-login/",
      { username: u, password: p, company: c },
      cfg
    );
    return res.data;
  } catch (err) {
    if (err?.response?.status === 403) {
      await csrfBootstrap(c);
      const res2 = await api.post(
        "/public_auth/universal-login/",
        { username: u, password: p, company: c },
        cfg
      );
      return res2.data;
    }
    const msg =
      err?.response?.data?.error ||
      err?.response?.data?.detail ||
      err?.message ||
      "Erreur de connexion.";
    const e = new Error(msg);
    e.status = err?.response?.status;
    throw e;
  }
};
